module.exports = "<app-top-bar [showBackButton]=\"false\" title=\"Home\"></app-top-bar>\n\n<section class=\"unlogged container text-center\">\n\t<p><i class=\"icon-empty-library\"></i></p>\n\t<p i18n=\"@@no_connection\">No connection !</p>\n\t<button routerLink=\"/library\" i18n=\"@@go_to_library\">Navigate to Library</button>\n\t<!-- <p i18n=\"@@or\">Or</p>\n\t<button class=\"reverse\"><i class=\"icon-reload\"></i><span i18n=\"@@reload\"> Reload</span></button> -->\n</section>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/no-connection/no-connection.component.html
// module id = ./src/app/no-connection/no-connection.component.html
// module chunks = main